import { useTranslation } from 'react-i18next'

import { useBookRentalPortalViewing } from '../../../../../../RentalPortalViewing'
import { useRentalPortalProfileHeaderFooterMeasure } from '../../../../../RentalPortalProfileHeaderFooter'
import {
  useListingProfileArchiveAction,
  useListingProfileContext,
  useListingProfileRestoreAction,
} from '../../../RentalPortalListingProfile.hooks'
import { getListingProfileTitle } from '../../../RentalPortalListingProfile.utils'
import {
  LISTING_PROFILE_HEADER_FOOTER_ACTION,
  LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION,
} from '../../RentalPortalListingProfileHeaderFooter.constants'
import {
  getIsListingProfileHeaderFooterOnlyMore,
  getListingProfileHeaderFooterActions,
} from '../../RentalPortalListingProfileHeaderFooter.utils'
import { useListingProfileUploadFileAction } from '../useListingProfileUploadFileAction'

export function useListingProfileHeaderFooter() {
  const { t } = useTranslation()

  const { handleEntityReload, listingData } = useListingProfileContext()

  const { handleClickArchive } = useListingProfileArchiveAction()

  const { handleClickRestore } = useListingProfileRestoreAction()

  const { getUploadFileInputProps, handleClickUploadFile } =
    useListingProfileUploadFileAction()

  const { bookViewingModal, handleOpenBookViewing } =
    useBookRentalPortalViewing({
      onBooked: handleEntityReload,
    })

  function handleClickBookViewing() {
    handleOpenBookViewing({
      listing: {
        label: getListingProfileTitle({ listingData, t }),
        value: listingData.id,
      },
    })
  }

  const actionHandlers = {
    [LISTING_PROFILE_HEADER_FOOTER_ACTION.bookViewing]: handleClickBookViewing,
    [LISTING_PROFILE_HEADER_FOOTER_ACTION.uploadDocument]:
      handleClickUploadFile,
    [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.archive]:
      handleClickArchive,
    [LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION.restore]:
      handleClickRestore,
  }

  const actions = getListingProfileHeaderFooterActions({ listingData, t })

  const measure = useRentalPortalProfileHeaderFooterMeasure({ actions })

  function handleSelectMoreOption({ disabled, value }) {
    return disabled ? null : actionHandlers[value]?.()
  }

  return {
    ...measure,
    actionHandlers,
    bookViewingModal,
    getUploadFileInputProps,
    handleSelectMoreOption,
    hasActions: actions.length > 0,
    isOnlyMoreWithAddNewText: getIsListingProfileHeaderFooterOnlyMore(measure),
  }
}
